export default __webpack_public_path__ + "static/media/ic_menu_handle.dc886831.svg";